import { Box, Flex, Text, Input } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useState, useRef, useEffect } from 'react';

export default function ContactInfoInput(props) {
	const { t } = useTranslation();
	const { value, onChange, label, disabled, lastChanged, loading } = props;

	const [inputValue, setInputValue] = useState(value ?? '');
	const isFirstRender = useRef(true);

	useEffect(() => {
		setInputValue(value ?? '');
	}, [value]);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}

		if (onChange) {
			onChange(inputValue);
		}
	}, [inputValue]);

	const lastChangedDisplay = lastChanged && lastChanged.toString().trim() !== '' ? lastChanged : 'N/A';

	return (
		<Flex flexDirection="column" mb={4}>
			<Flex justifyContent="flex-start" alignItems="center" p={1} pl={2} pr={2} style={{ pageBreakInside: 'avoid' }} _hover={{ bg: 'gray.200' }}>
				<Text ml="5" mr="2" fontWeight="500" w="120px" minW="120px">
					{t(label)}:
				</Text>

				<Box ml="2" mr="4" flex="1">
					<Input
						isDisabled={disabled || loading}
						value={inputValue}
						onChange={(e) => setInputValue(e.target.value)}
						variant="outline"
						size="md"
						fontSize="sm"
						maxW="150px"
						placeholder={t('Enter value')}
					/>
				</Box>
			</Flex>
			{/* <Flex justifyContent="flex-start" alignItems="center" pl={2} pr={2} style={{ pageBreakInside: 'avoid' }}>
				<Text mr="2" fontWeight="500" w="120px" minW="120px">
					{t('Last Changed')}:
				</Text>

				<Text ml="2" mr="4" flex="1">
					{lastChangedDisplay}
				</Text>
			</Flex> */}
		</Flex>
	);
}
